module.exports = __webpack_public_path__ + "static/media/plataforma_jamira.2dcf972d.png";